import { render, staticRenderFns } from "./indexFriend.vue?vue&type=template&id=1dce5336&scoped=true&"
import script from "./indexFriend.vue?vue&type=script&lang=js&"
export * from "./indexFriend.vue?vue&type=script&lang=js&"
import style0 from "./indexFriend.vue?vue&type=style&index=0&id=1dce5336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dce5336",
  null
  
)

export default component.exports